// extracted by mini-css-extract-plugin
export default {"box":"profile_edit_nav_box-module___box___a4c8fb3f"};